import { render } from "./ForgotPasswordSubmit.vue?vue&type=template&id=3dbd19c3"
import script from "./ForgotPasswordSubmit.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSubmit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__